<div class="page__content">
<!--   <div class="content__inner">
    <div class="content__login row">
      <div *ngIf="tfaFlag" class="col-sm-12">
        <h1>{{ 'LOGIN.TFA_HEADER' | translate }}</h1>
        <h6>{{ 'LOGIN.TFA_INTRO' | translate }}</h6>
      </div>
      <div class="card__login">
        <form [formGroup]="form">
          <div *ngIf="!isLoggedIn && !tfaFlag && !resetQR">
            <h1>{{ 'LOGIN.SUBMIT' | translate }}</h1>

            <div class="form-group">
              <input type="email" class="form-control" name="email" formControlName="email" required email
                [placeholder]="'PLACEHOLDER.EMAIL' | translate" [ngClass]="{'is-invalid': submitted && this.form.controls['email'].errors}" />
            </div>
            <div class="form-group">
              <input type="password" class="form-control" name="password" formControlName="password"
                [placeholder]="'PLACEHOLDER.CONTRASENA' | translate"
                [ngClass]="{'is-invalid': submitted && this.form.controls['password'].errors}" />
            </div>
            <div class="form-group">
              <button class="btn btn-primary btn-block" (click)="onSubmit()">{{ 'LOGIN.SUBMIT' | translate }}</button>
              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            </div>

            <div class="form-group">
              <a routerLink="../forgot-password" class="forgot-password">{{ 'LOGIN.FORGOT_PASSWORD' | translate }}</a>
            </div>
            <div class="form-group">
              <h6 class="float-derecha">{{ 'LOGIN.NO_ACCOUNT' | translate }}</h6>
              <button class="btn btn-secondary-b btn-block" (click)="redireccion()">{{ 'HEADER.CLAVE' | translate }}</button>
            </div>
          </div>

          <div *ngIf="tfaFlag">
            <input type="text" class="form-control mb-3 text-center" autocomplete="off"
              [placeholder]="'PLACEHOLDER.CODIGO_DE_UN_SOLO_USO' | translate" formControlName="totpkey" name="totpkey"
              [ngClass]="{'is-invalid': submitted && this.form.controls['totpkey'].errors}" maxlength="6" />
            <div class="form-group">
              <button class="btn btn-primary btn-block" (click)="loginTfaEnabled()">{{ 'COMMON.BUTTON.CONFIRM' | translate }}</button>
              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
            </div>
          </div>
        </form>
        <div *ngIf="resetQR && !resetedQR" class="centerQR">
          <div id="qr">
            Se ha solicitado un reestablecimiento de Two Factor.
            Vuelva a escanear el código QR con la aplicación Authenticator en su móvil
            <div>
              <img [src]=qr.secretURL class="m-2" />

              <form [formGroup]="form2" (ngSubmit)="guardarQR()">
                <div class="d-flex justify-content-center">
                  <input type="text" name="totpkey" formControlName="totpkey"
                    class="col-sm-4 mr-2 text-center form-control" [placeholder]="'PLACEHOLDER.CODIGO_AUTHENTICATOR' | translate" maxlength="6"
                    [ngClass]="{'is-invalid': submitted && this.form2.controls['totpkey'].errors}">
                  <button type="submit" class="btn btn-primary m-left">{{ 'PROFILE.ACTIVATE_2FA' | translate }}</button>
                </div>
              </form>
            </div>
            <div *ngIf="errorQR" class="m-2">
              <p>{{ 'PROFILE.TFA_ERROR' | translate }}
              </p>
            </div>
          </div>
        </div>
        <div class="alert alert-success" *ngIf="isLoggedIn">
          <div *ngIf="midata | json">
            <p>
              Conectado como <br /><strong>{{ midata["nombre"] }}</strong>
            </p>
            <p>
              MI id es: <br /><strong>{{ midata["id"] }}</strong>
            </p>
          </div>
        </div> 
      </div>
    </div>
    <div class="text-center">
      <p *ngIf="resetedQR">Two factor activado, se le redirigirá a la página de login de nuevo</p>
    </div>
  </div> -->
</div>